module.exports = __webpack_public_path__ + "img/Einsatzeinheit.ee4fa1ca.svg";